import React from 'react';
import type { TagData } from '@hub/features/account-dashboard/types/tag-data.types';
import { Program } from '@monorepo/types';
import { ClickableTitle } from '../../clickable-title';
import { DesktopContainer, DesktopContentContainer } from '../styled';
import { getProgramDisplayText, renderStatusTag, renderTag } from '../utils';

interface DesktopHeaderViewProps {
  tagData: TagData;
  program: Program | undefined | null;
  isMenuOpen: boolean;
  desktopAnchorRef: React.RefObject<HTMLDivElement | null>;
  onMenuToggle: () => void;
}

export const DesktopHeaderView: React.FC<DesktopHeaderViewProps> = ({
  tagData,
  program,
  isMenuOpen,
  desktopAnchorRef,
  onMenuToggle,
}) => {
  return (
    <DesktopContainer>
      {renderTag(
        tagData.tradingInstrument.label,
        tagData.tradingInstrument.color,
      )}

      <DesktopContentContainer>
        <ClickableTitle
          ref={desktopAnchorRef}
          title={getProgramDisplayText(program?.name)}
          isOpen={isMenuOpen}
          onClick={onMenuToggle}
        />
        {renderStatusTag(tagData)}
        {renderTag(tagData.accountType.label, tagData.accountType.color)}
      </DesktopContentContainer>
    </DesktopContainer>
  );
};
